import { createContext } from 'react';
import { useFiltersContext } from '../../../../../Dashboards/Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_SIA, useChartsData } from '../../../../Common/hooks/useChartsData';
import { subtitlesMap } from '../../../Common/maps/subtitleMap';

export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SIA.PRODUCTION_QUANTITY,
            url: 'governanceroom/dashboard/services/production/quantity'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value,
        }
    );

    const chartData = data ? {
        indexes: data.indexes || [{
            quantitade_aprovada: 0,
            quantidade_produzida: 0,
            indice_eficacia: 0,
        }],
        selectedYear: data.selectedYear || [],
    } : {
        indexes: [{
            quantitade_aprovada: 0,
            quantidade_produzida: 0,
            indice_eficacia: 0,
        }],
        selectedYear: [],
    };


    const subtitlesSelectedYear = subtitlesMap[QUERY_KEYS_SIA.PRODUCTION_QUANTITY].map(
        (item) => item.description
    );

    const colors = subtitlesMap[QUERY_KEYS_SIA.PRODUCTION_QUANTITY].map((item) => item.color);

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                subtitlesSelectedYear,
                colors,
                isLoading,
                isError,
                filters,
                module,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
